import React from 'react'
import {Swiper, SwiperSlide} from 'swiper/react'
import {Navigation, Pagination, Keyboard} from 'swiper/modules'
import {useStyleConfig, Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {ChevronLeft, ChevronRight} from '../../icons'
import PropTypes from 'prop-types'
import RecipeUtilityTile from './recipe-utility-tile'
import {remCalc} from '../../../theme/_utils'

const ToolsCarousel = ({productsGroup = []}) => {
    const styles = useStyleConfig('Sorting')
    const swiperStyles = useStyleConfig('Swiper')
    const componentUniqueKey = 'recipe-utensils-carousel'
    const variant = 'white'
    return (
        <Box width="100%" position="relative" __css={{...swiperStyles}}>
            <Swiper
                data-testid="recipe-utilensils-swiper"
                modules={[Navigation, Pagination, Keyboard]}
                navigation={{
                    prevEl: `.swiper-button-prev-${componentUniqueKey}`,
                    nextEl: `.swiper-button-next-${componentUniqueKey}`,
                }}
                pagination={{
                    clickable: true,
                    el: `.swiper-pagination-${componentUniqueKey}`,
                }}
                keyboard={{
                    enabled: true,
                }}
                loop={true}
                // Not intended to be used loop mode and grid.rows
                // centerInsufficientSlides={true}
                breakpoints={{
                    0: {
                        slidesPerView: 1,
                        enabled: productsGroup.length > 1,
                        spaceBetween: 0,
                    },
                    768: {
                        slidesPerView: 2,
                        enabled: productsGroup.length > 2,
                        spaceBetween: 16,
                    },
                    1500: {
                        slidesPerView: 3,
                        enabled: productsGroup.length > 3,
                        spaceBetween: 16,
                    },
                    1920: {
                        slidesPerView: 4,
                        enabled: productsGroup.length > 4,
                        spaceBetween: 16,
                    },
                }}
            >
                {productsGroup.length > 0 &&
                    productsGroup.map((tile, tIndex) => (
                        <SwiperSlide
                            style={{display: 'flex', justifyContent: 'center'}}
                            key={`swiper-tile-${componentUniqueKey}-${tIndex}`}
                        >
                            <RecipeUtilityTile
                                key={`recipe-utensil-tile-${componentUniqueKey}-${tIndex}`}
                                styles={styles}
                                tile={tile}
                                variant={variant}
                            />
                        </SwiperSlide>
                    ))}

                <ChevronLeft
                    className={`swiper-button-prev swiper-button-prev-${componentUniqueKey}`}
                    aria-label="swiper button prev icon"
                    {...styles.chevronIcon}
                    borderWidth={remCalc(0)}
                    borderColor="none"
                    borderRadius="unset"
                    backgroundColor="transparent"
                    color="text.primary"
                    left={0}
                />
                <ChevronRight
                    className={`swiper-button-next swiper-button-next-${componentUniqueKey}`}
                    aria-label="swiper button next icon"
                    {...styles.chevronIcon}
                    borderWidth={remCalc(0)}
                    borderColor="none"
                    borderRadius="unset"
                    backgroundColor="transparent"
                    color="text.primary"
                    right={0}
                />
                <Box
                    textAlign="center"
                    className={`swiper-pagination-${componentUniqueKey}`}
                    py={remCalc(24)}
                />
            </Swiper>
        </Box>
    )
}

ToolsCarousel.propTypes = {
    productsGroup: PropTypes.array,
}

export default ToolsCarousel
